import { urlBuilder } from '@torim-app/utils';

const serverHost = `${import.meta.env.VITE_BACKEND_URL}`

export const platformUrlBuilder = (
  queryParams: Record<string, string | number>,
  path = '',
): string => {
  return urlBuilder(`${serverHost}/platform`, queryParams, path);
};

export const platformFetch = (url: string, options: RequestInit = {}): Promise<Response> => {
  return fetch(url, {
    ...options,
    credentials: 'include',
    headers: {
      'content-type': 'application/json',
      ...options.headers,
    },
  });
};
